var map = {
	"./assets/abroadIncomeFalseForeignCompanyNoReport.svg": "08efc60b16a79bae8320",
	"./assets/abroadIncomeFalseForeignCompanyReport.svg": "969650d97f9855786c61",
	"./assets/abroadIncomeForeignCompanyNoReport.svg": "401bdf30f0fe85e8afef",
	"./assets/abroadIncomeForeignCompanyReport.svg": "570df28ad43c50d03abb",
	"./assets/addresses.svg": "a1a2e83f950782e10ee8",
	"./assets/airbnb.svg": "ecf2a97873e63f38147b",
	"./assets/arrowDown.svg": "9f2dc6a1e272f2fbcc4d",
	"./assets/arrowDownRed.svg": "d0e24ce3ecf4bef4ce55",
	"./assets/arrowLeft.svg": "a2f11fae7cc8019733a3",
	"./assets/arrowRight.svg": "12ab9b87440c142020e2",
	"./assets/arrowUp.svg": "229571c6ca3bf2a18c6e",
	"./assets/bear.svg": "06890f98dc1b88dab1f6",
	"./assets/bell.svg": "8bc33568e7b1a6662bb5",
	"./assets/businesses.svg": "b5dd839eab6dc21abed8",
	"./assets/businessman.svg": "276ee64eea75636c6126",
	"./assets/cake.svg": "9efc8e72baff34e611a6",
	"./assets/calendar.svg": "37a2252d3c35fab72ae9",
	"./assets/cart.svg": "38032c99b3bfafb23194",
	"./assets/check-circle-blue.svg": "c987006207c3c9afd2c3",
	"./assets/checked.svg": "e38cec2b181e0000880b",
	"./assets/close-thin.svg": "016983d4727a2f25414d",
	"./assets/close.svg": "02148a5aa0c242db4543",
	"./assets/coin.svg": "0110aa3e21fe7ef7ef16",
	"./assets/collapse.svg": "5162b9acf39742dfef5c",
	"./assets/columns.svg": "d41896d021de7d98d2cf",
	"./assets/columnsBlue.svg": "0d79489fbf9dd445cda1",
	"./assets/company-overview.svg": "0ae8a9c56d8d1c8769a5",
	"./assets/contact.svg": "843ed595acedc74824a8",
	"./assets/copy-gray.svg": "1e516422e28952b89ea5",
	"./assets/copy.svg": "8d5464de23898efd70f0",
	"./assets/create.svg": "74b379e29c4d5045bc17",
	"./assets/cryptoDefault.svg": "11066127397e6b0f0b42",
	"./assets/dashboard.svg": "5e87d229415aff1bb1ce",
	"./assets/data-science.svg": "3afcac61610a5009e34c",
	"./assets/delete.svg": "0b7417e96024605b61a1",
	"./assets/deselect.svg": "b9cf276356697fd36d7b",
	"./assets/diamond.svg": "4e4a0fa8617677ea6861",
	"./assets/documented.svg": "40bcac8d09dc47cbf916",
	"./assets/documentedRevenue.svg": "d2283974629079b5da78",
	"./assets/dollar.svg": "722afd37ccbd6af7acfe",
	"./assets/done.svg": "95c5ce7ce1211c021c5e",
	"./assets/dropdownArrowDown.svg": "c4ac4d44ac89c2f656e1",
	"./assets/dropdownArrowUp.svg": "f29d492c60139cd0e174",
	"./assets/dropdownSearch.svg": "d764633ddb20edb842a3",
	"./assets/ecommerce-extended.svg": "a0049b7d120889419cbb",
	"./assets/ecommerce.svg": "e820ab2d1b1f9a35e5b7",
	"./assets/economy.svg": "c3fb6595524560d8592b",
	"./assets/edit.svg": "4d4d1d1466578588780e",
	"./assets/emails.svg": "262ffabdc6b409433757",
	"./assets/employees.svg": "a8e3aefb36a560c31679",
	"./assets/expand.svg": "53094c96f4fb9cb16f4a",
	"./assets/exportFile.svg": "ea20b450d54f65fdf814",
	"./assets/fatca.svg": "ad7baf3739eca2f6b07b",
	"./assets/filter-calendar.svg": "3c14c9cae40c613f8d90",
	"./assets/filter.svg": "75efd2e7dbcbe2cd7362",
	"./assets/filterBlue.svg": "ed78fb306db535f8f9a2",
	"./assets/filters.svg": "0908100c65dc2892e999",
	"./assets/filtersCounter.svg": "fa421cce8355583ec4cd",
	"./assets/foreignRegionReport.svg": "a79f11eea3886014f96b",
	"./assets/freelancers.svg": "1908bb26621ff5bdd5b0",
	"./assets/half-checked.svg": "f3fa553a85fd2bf232d5",
	"./assets/highest.svg": "22b586639014ad85c58b",
	"./assets/home.svg": "3e7837ed9a42d43f334d",
	"./assets/homeaway.svg": "a1eb0a78dd4d33eb0045",
	"./assets/influencers.svg": "d13f99e012ae04a53e7f",
	"./assets/info.svg": "11f49cee2efa9fceeb77",
	"./assets/information.svg": "f9dfadad3a60b60c9fb8",
	"./assets/license.svg": "3452f14219e80fedfe9c",
	"./assets/licenses.svg": "09e551e7e362592d2861",
	"./assets/listIcon.svg": "4fbad38a0efd161dcf7d",
	"./assets/logo.svg": "e1973c51610840bec835",
	"./assets/logout.svg": "c5d21ce7bf2be8e4bab7",
	"./assets/logox.svg": "d7c6c05189a1e1c27c9a",
	"./assets/lowest.svg": "a8fe92d2316d4ea71f65",
	"./assets/map.svg": "e32d4e8fd1a91d3d33a6",
	"./assets/medium.svg": "f904d02d2a0210d76591",
	"./assets/midrag.svg": "3cc46a0996b414967688",
	"./assets/navigationHome.svg": "d7e953087440a72b05ef",
	"./assets/nft.svg": "cdf63119653b16693943",
	"./assets/no-results.svg": "bc454aa41f084a8d53d9",
	"./assets/noActivity.svg": "5844cea4df40dd3c2dd6",
	"./assets/noFile.svg": "4641e78cb3470c638e81",
	"./assets/noFile_oleHadash.svg": "de914ea60c0566f94e5a",
	"./assets/noReport.svg": "8ea4dee5fa24b52c17d7",
	"./assets/noReport_oleHadash.svg": "f953c561248925db3a9d",
	"./assets/nonFiler.svg": "275a0db58a9f95f79156",
	"./assets/nonFilerV2Orange.svg": "dc08f911f0bdda80c4a7",
	"./assets/nonFilerV2Red.svg": "a59fb50118ff2635f79f",
	"./assets/nonRegister.svg": "0fef5c06c69bfede14d4",
	"./assets/notes.svg": "efbec4fdecd9620a7ef9",
	"./assets/offshore.svg": "3c1b3dd3c987d5fbf5f2",
	"./assets/organizations.svg": "61f8e2f01f62b68cd982",
	"./assets/owners.svg": "d7368b7d1cfbac14a1af",
	"./assets/permit.svg": "366c49b2b60d58639d2d",
	"./assets/phones.svg": "ea4062b6ba95d8463ca6",
	"./assets/placePin.svg": "98f2696e3302fcdf5d07",
	"./assets/preview.svg": "74a8c9332112081ba0dd",
	"./assets/processing.svg": "ef7f4bb1a1c351ff3be6",
	"./assets/projectReview.svg": "00a2cc96c1c748de57a5",
	"./assets/properReport.svg": "ee3201b460b69f6657fd",
	"./assets/properReport_oleHadash.svg": "79262ef0eaeb14229aff",
	"./assets/reload.svg": "8432daae26cc675c4944",
	"./assets/rentals.svg": "08c141902d716b646ff2",
	"./assets/resetPassword.svg": "80c068e921b55ea976c8",
	"./assets/review.svg": "ff7569834f845b2ea2d3",
	"./assets/search-lg-black.svg": "67e31e64ab88afcf7fe7",
	"./assets/search-lg-grey.svg": "6f6fdbb9ece3e0d4582c",
	"./assets/search-md-grey.svg": "582a64307c8294ed8dfd",
	"./assets/search.svg": "651313caf8c0af271278",
	"./assets/searchLarge.svg": "e4565b9ecbaf2f8f6325",
	"./assets/selectArrow.svg": "a1073a53ef53391aa61e",
	"./assets/service-providers.svg": "8e2fc3b0e528112a650c",
	"./assets/settings.svg": "648a6845d3084e38dddb",
	"./assets/share.svg": "30bf7ee669930b44fbbb",
	"./assets/short-term-rentals.svg": "2e961462b463bf748909",
	"./assets/social.svg": "60f171ac00f66a88d38f",
	"./assets/sort.svg": "3da7bc9fa2f022724178",
	"./assets/star.svg": "f8adf19f480aa6063a5f",
	"./assets/tax.svg": "29329a5ec41ae86751e1",
	"./assets/unchecked.svg": "ee55a3320301bb7d1ae6",
	"./assets/underReport.svg": "632aec659973d1fa3c44",
	"./assets/underReport_oleHadash.svg": "31d9a477e3c09b01cbbc",
	"./assets/underReportedV2Orange.svg": "fe27e9792d0b4a99589e",
	"./assets/underReportedV2Red.svg": "df188a48ecee92aa1eab",
	"./assets/underReportedV2Yellow.svg": "13f18cf2ddc7dc901b6d",
	"./assets/union.svg": "55d349893d7b5c329b03",
	"./assets/upload.svg": "87c4441a86c7f84d01a6",
	"./assets/verified-filled.svg": "acdc4ab149f95f326849",
	"./assets/verified.svg": "fb50aa1d64d0a4987553",
	"./assets/waitingForReport.svg": "d9b2e44f42375bdba8f2",
	"./assets/waitingForReport_oleHadash.svg": "3460776e2823b0996256",
	"./assets/wallet.svg": "214de0c999ceee9acee1",
	"./assets/wallets.svg": "f95bde63c8520121a014",
	"./assets/weblinks.svg": "66cec9d925210d5a64c0",
	"./assets/webpage.svg": "5ede1bd6c785e32f988c",
	"./assets/zeroReportedV2Orange.svg": "61cafd9320b2afab679e",
	"./assets/zeroReportedV2Red.svg": "7c088a8c3ceace2675d9",
	"./rentals/hosts-active.svg": "1cf451e68b3b4a7739b5",
	"./rentals/hosts-inactive.svg": "eeb2f996a392b6413be7",
	"./rentals/listings-active.svg": "0fcbe51277882e7c1bdc",
	"./rentals/listings-inactive.svg": "3e95753a850236ae3109"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "11230aed7539ea8052b6";